export default {
  "app-layout": () => import("/codebuild/output/src1217916800/src/layouts/app-layout.vue").then(m => m.default || m),
  default: () => import("/codebuild/output/src1217916800/src/layouts/default.vue").then(m => m.default || m),
  "embedded-content": () => import("/codebuild/output/src1217916800/src/layouts/embedded-content.vue").then(m => m.default || m)
}